import { parseApiCalendarDate, toApiCalendarDate } from 'utils/calendarDate';

const toDateKey = value => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  return toApiCalendarDate(parseApiCalendarDate(value) ?? value);
};

export const hasTrainingPartScheduleImpactFieldsChanged = (initialValues, payload) => {
  const nextAvailableTo = toDateKey(payload?.availableTo);
  const prevAvailableTo = toDateKey(initialValues?.availableTo);
  const nextValidity = Number(payload?.validityMonthCount ?? 0);
  const prevValidity = Number(initialValues?.validityMonthCount ?? 0);

  return nextAvailableTo !== prevAvailableTo || nextValidity !== prevValidity;
};

export default hasTrainingPartScheduleImpactFieldsChanged;
